import * as React from 'react';
import { Row } from 'antd';
import { Helmet } from 'react-helmet-async';
import dataEvents from '../../awards_events_data.json';
import { EventDataType } from '../../../../common/types';
import EventCardItem from '../card/EventCardItem';

// const PStyled = styled.p`
//   font-size: 16px;
// `;

interface TabEventPhotosAwardsProps {
}

export const TabEventPhotosAwards: React.FC<TabEventPhotosAwardsProps> = () => {
  const eventsData = Array.from(Object.values(dataEvents)) as EventDataType[];

  return (<>
      <Helmet>
          <title>EVENT PHOTOS</title>
          <meta
              name="description"
              content="AWMAC - Architectural Woodwork Manufacturers Association of Canada AWARDS"
          />
          <link rel="canonical" href='https://awmacbc.com/awards/photos'/>
      </Helmet>
          <Row align="stretch" gutter={[20, 20]}>
            {
                eventsData.map((event) => <EventCardItem key={event.id} dataCard={event}/>)
            }
          </Row>
      </>
  );
};
